import { firstLetterUppercase } from '@/helpers/string.helpers'
import moment from 'moment'
import i18n from '@/plugins/i18n'
import { getNormalizedLocale } from '@/helpers/i18n.helpers'

export function formatDate(date, format, englishVersion) {
	return date.toLocaleDateString(englishVersion ? 'en' : getNormalizedLocale(), format)
}

export function localeDate(date){
	return moment(date).locale(getNormalizedLocale())
}

export function formatDateForGraphAxis (date) {
	let result = formatDate(date, { month: 'short', day: 'numeric' })
	return result
}

export function formatDateByMonth (date) {
	let result = formatDate(date, {month: 'short', year: '2-digit'})
	return result
}

export function formatDateByMonthLong (date) {
	let result = formatDate(date, { month: 'long', year: 'numeric' })
	return result
}

export function getMonthName(date) {
	const month = formatDate(date, { month: 'long' })
	return firstLetterUppercase(month)
}

export function getWeekDaysNames(startsOnSunday = false, englishVersion = false) {
	const weekDays = []
	const date = new Date()
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)))
	for (let i = 0; i < 7; i++) {
		weekDays.push(formatDate(date, { weekday: 'long' }, englishVersion))
		date.setDate(date.getDate() + 1)
	}
	return weekDays
}

export function getWeekDaysNamesWithValue(startsOnSunday = false, englishVersion = false) {
	const weekDays = []
	const date = new Date()
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)))
	for (let i = 0; i < 7; i++) {
		weekDays.push({ name: formatDate(date, { weekday: 'long' }, englishVersion), value: i })
		date.setDate(date.getDate() + 1)
	}
	return weekDays
}

export function getMonthShortName(date) {
	const month = formatDate(date, { month: 'short' })
	return firstLetterUppercase(month)
}

export function getWeekDayShortName(date) {
	const weekday = formatDate(date, { weekday: 'short' })
	return firstLetterUppercase(weekday)
}

export function getWeekDaysShortNames(startsOnSunday = false) {
	// Get week days short names ordered in week
	const weekDays = []
	const date = new Date()
	date.setDate(date.getDate() - (date.getDay() - (startsOnSunday ? 0 : 1)))
	for (let i = 0; i < 7; i++) {
		weekDays.push(getWeekDayShortName(date))
		date.setDate(date.getDate() + 1)
	}
	return weekDays
}

export function getDDMMYYYY(date) {
	return formatDate(date, { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function getDateFromDateAndHour (date, hour) {
	let dateObj = new Date(date)
	return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), hour.split(':')[0], hour.split(':')[1])
}

export function getCurrentDateFromHour (hour) {
	return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), hour.split(':')[0], hour.split(':')[1])
}

export function formatSearchDate (date) {
	if (!date) return ''
	let utcDate = utcDateToUtcFormat(date)
	const dateWithLocale = localeDate(utcDate)
	let daysDifference = Math.round((dateWithLocale - new Date()) / (1000 * 3600 * 24))
	return `${daysDifference < 7 ? dateWithLocale.calendar() : dateWithLocale.format('DD MMM HH:mm')}`
}
export function appointmentDateFormat(date, reduced, noHours = false) {
    if (!date) return '';
    const dateWithLocale = localeDate(typeof date === 'string' ? utcDateToUtcFormat(date) : date);
    let formattedDate = dateWithLocale.format(`${reduced ? '' : 'dddd, '}DD [${reduced ? '' : i18n.t('ofLabel')}] MMMM [${reduced ? '' : i18n.t('ofLabel')}] YYYY`);
    if (!noHours) {
        formattedDate += ` ${reduced ? '' : i18n.t('at-time')} ${dateWithLocale.format('LT')}`;
    }
    return formattedDate;
}

export function longDateFormat (date, withoutHour) {
	if (!date) return ''
	const dateWithLocale = localeDate(date)
	return `${dateWithLocale.format(`${'dddd, '}DD [${i18n.t('ofLabel')}] MMMM [${i18n.t('ofLabel')}] YYYY`)}${` ${withoutHour ? '' : `${i18n.t('at-time')} ${dateWithLocale.format('LT')}` }`}`
}
export function utcDateToUtcFormat (date) {
	if (!date) return ''
	return new Date(date.indexOf('Z') > -1 ? date : `${date}Z`)
}
export function getTime (date) {
	if (!date) return ''
	return localeDate(date).format('LT')
}
export function getLocalHourFromDate (date) {
	return moment(date).format('HH:mm')
}
export function calculateAge (date) {
	const today = new Date()
	let age = today.getFullYear() - date.getFullYear()
	if (today.getMonth() < date.getMonth() || (today.getMonth() === date.getMonth() && today.getDate() < date.getDate())) {
		age -= 1
	}
	return age
}
export function dateIsBeforeToday (date) {
      return moment(date).isBefore(moment(new Date()))
}


// WEBPACK FOOTER //
// ./src/helpers/date.helpers.js